import React from 'react';
import { Link } from 'react-router-dom';
import affiliateService from '../../Services/affiliateService';

/**
 * AffiliateLink Component
 * A wrapper around React Router's Link that automatically includes affiliate ID
 */
const AffiliateLink = ({ to, children, ...props }) => {
  // Build URL with affiliate ID if available
  const urlWithAffiliate = affiliateService.buildUrlWithStoredAffiliate(to);

  return (
    <Link to={urlWithAffiliate} {...props}>
      {children}
    </Link>
  );
};

export default AffiliateLink;
